// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiURL: 'http://127.0.0.1:9292/',
  apiURL: 'https://staging.singstravel.co.uk/',
  apiFelloh: 'https://adapter.sandbox.felloh.com/felloh-checkout-service/v1/',
  apiFellohNew: 'https://sandbox.felloh.com/',
  fellohPayGate: 'https://pay.sandbox.felloh.com/'
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
